// Product.js
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCart } from "./CartContext"; // ✅ Import context

function Product({ id, name, image, price = 10000, percentOff }) {
  const { addToCart } = useCart(); // ✅ Lấy hàm addToCart từ context

  let percentBadge;
  let offPrice = `${price}Đ`;

  if (percentOff && percentOff > 0) {
    percentBadge = (
      <div
        className="badge bg-dim py-2 text-white position-absolute"
        style={{ top: "0.5rem", right: "0.5rem" }}
      >
        {percentOff}% OFF
      </div>
    );

    offPrice = (
      <>
        <del>{price}Đ</del> {price - (percentOff * price) / 100}Đ
      </>
    );
  }

  const handleAdd = () => {
    addToCart({
      id,
      name,
      price,
    });
  };

  return (
    <div className="col">
      <div className="card shadow-sm">
        <Link to={`/products/${id}`} replace>
          {percentBadge}
          <img
            className="card-img-top bg-dark cover"
            height="200"
            alt={name}
            src={image}
          />
        </Link>
        <div className="card-body">
          <h5
  className="card-title text-center text-dark"
  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
>
  {name}
</h5>


          <p className="card-text text-center text-muted mb-0">{offPrice}</p>
          <div className="d-grid d-block">
            <button
              className="btn btn-outline-dark mt-3"
              onClick={handleAdd} // ✅ Gọi từ context
            >
              <FontAwesomeIcon icon={["fas", "cart-plus"]} /> Add to cart
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;
